import { Modal, Form, Input, Button, Col, Row } from "antd";
import { useEffect, useState } from "react";
import MaskedInput from "antd-mask-input";
import SelectCommercialActivityType from "../../Elements/Select-Comercial-Activity";
import SelectCities from "../../Elements/Select-Cities";
import { create_entity } from "../../../../../controllers/store/actions/entities/create-entities-actions";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import SelectStates from "../../Elements/Select-States";
import { Actor } from "../../../..";
import SelectProducts from "../../Elements/Select-Product-";
import SelectSearchers from "../../Elements/Select-Searcher";
interface Props {
  loading?: boolean;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewEntityModal = (Props: Props) => {
  const [form] = Form.useForm();
  const entityCreated = useSelector((state: any) => state.entityCreated);
  const [state, setState] = useState<any>();
  const actorTypesState = useSelector((state: any) => state.actorTypes);

  useEffect(() => {}, []);

  return (
    <Modal
      width={800}
      open={Props.visible}
      title={"Entidad"}
      okText={"Crear entidad"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values: any) => {
              const ciiu = values.commercial_activity.map((e: any) => ({
                comercial_activity_id: e.value,
              }));

              await dispatch(
                create_entity({
                  ...values,
                  universities: values.universities?.map((e: any) => ({
                    universities_id: e.value,
                  })),
                  searchers: values.searchers?.map((e: any) => ({
                    searchers_id: e.value,
                  })),
                  products: values.products?.map((e: any) => ({
                    products_id: e.value,
                  })),
                  city: values.city.value,
                  actor_type: actorTypesState.list.find(
                    (actor: any) => actor.collection_name === Actor.Company
                  ).id,
                  state: values.state.value,
                  ciiu,
                })
              );
              form.resetFields();
              Props.onCreated();
            });
          }}
          name="newEntity"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Empresa"
                name="social_reason"
                rules={[{ type: "string", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="NIT"
                name="nit"
                rules={[{ type: "string", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[{ type: "string", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={8} sm={6} md={12} lg={12}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[{ type: "email", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Descripción"
                name="description"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Caracteristicas"
                name="features"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={3} sm={6} md={12} lg={24}>
              <Form.Item label="Actividad económica" name="commercial_activity">
                <SelectCommercialActivityType
                  placeholder="Actividad económica"
                  mode="multiple"
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value: string) => {}}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Departamento"
                name="state"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectStates
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("state", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  selectedState={state?.value}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("city", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Télefono de contacto"
                name="phone"
                rules={[{ type: "string", required: true }]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Dirección web"
                name="url"
                rules={[{ type: "string" }]}
              >
                <Input size="large" addonBefore="https://" defaultValue="" />
              </Form.Item>
            </Col>
          </Row>
          <Col xs={24} sm={12} md={8} lg={24}>
            <Form.Item
              label="Productos"
              name="products"
              rules={[{ type: "array" }]}
            >
              <SelectProducts
                onClear={() => {}}
                style={{ width: "100%" }}
                mode={"multiple"}
                size="large"
                onChange={(selected: any) => {
                  form.setFieldValue("products", selected);
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={24}>
            <Form.Item
              label="Investigadores"
              name="searchers"
              rules={[{ type: "array" }]}
            >
              <SelectSearchers
                onClear={() => {}}
                style={{ width: "100%" }}
                mode={"multiple"}
                size="large"
                onChange={(selected: any) => {
                  console.log("searchers select", selected);
                  form.setFieldValue("searchers", selected);
                }}
              />
            </Form.Item>
          </Col>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={entityCreated.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Crear Entidad
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};
export default NewEntityModal;
